import { PostHogSyncWrapper } from './sync/PostHogSyncWrapper';
import { usePostHogIdentify } from './usePostHogIdentify';

export function PostHogTracking() {
  const posthogReady = usePostHogIdentify();

  if (!posthogReady) {
    return null;
  }

  return <PostHogSyncWrapper />;
}
